var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57745 7.41074C3.90289 7.0853 4.43053 7.0853 4.75596 7.41074L10 12.6548L15.2441 7.41074C15.5696 7.0853 16.0972 7.0853 16.4226 7.41074C16.7481 7.73618 16.7481 8.26382 16.4226 8.58925L10.5893 14.4226C10.2639 14.748 9.73622 14.748 9.41079 14.4226L3.57745 8.58925C3.25201 8.26382 3.25201 7.73618 3.57745 7.41074Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownGray);
export default __webpack_public_path__ + "static/media/down_gray.a92aa2bf48fbe9ba5c87014ebd26f6a1.svg";
export { ForwardRef as ReactComponent };